<div class="modal-body">
    <div class="content">
        <h2 class="title" *ngIf="!hideTitle">
            {{
                step?.content?.compliance_criteria_type_id === COMPLIANCE_CRITERIA.HOURS
                    ? 'Submit ' + getUnitLabel
                    : 'Submit ' + getEntryLabel
            }}
        </h2>
        <cm-log-submit-tabs
            [activeTab]="activeSubmitTab"
            [form]="step.log_form"
            [step]="step"
            [hideMultipleTab]="hideMultipleTab"
            (tabChange)="onTabChange($event)"
        ></cm-log-submit-tabs>
        <cm-signature *ngIf="showSignature" class="signature-bar"></cm-signature>
        <div class="errors-container" [ngClass]="{ 'show-errors': !!error }">{{ error }}</div>
    </div>
</div>
<div class="modal-footer" *ngIf="!hideButtons">
    <button type="button" class="btn btn-default" (click)="goToPage.emit(PAGES.ENTRIES)">Back</button>
    <button
        type="button"
        class="btn btn-default"
        *ngIf="activeSubmitTab !== LOG_STEP_TABS.MULTIPLE && workflowTypeId === WORKFLOW_MODULE_ID.CREDENTIAL"
        (click)="reset()"
    >
        Reset
    </button>
    <button type="button" class="btn btn-primary" *ngIf="saveAsDraftEnabled" (click)="saveAsDraft()">
        Save as draft
    </button>
    <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
</div>
